// Pagina Ajustes (abre info de usuario y forma para cambio de password)

import React from 'react';

import UserDetailsCard from '../components/UserDetaildsCard';
import PasswordForm from '../components/PasswordForm';
import { useUser } from '../UserContext';
import { Box, Typography } from '@mui/material';
import { apiFetchJson } from '../fetchWrapper';

export default function Settings() {
  const { user, setUser } = useUser();

  const updateUser = async () => {
    const res = await apiFetchJson("/api/users/" + user.id);
    console.log("updated user", res);
  }

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Ajustes</Typography>
      </Box>
      <UserDetailsCard user={user} />
      <PasswordForm user={user} onSave={updateUser} />
    </section>
  );
}
